import { FC } from 'react';
import useLocales from '@hooks/useLocales';
import { Box, Button, Card, Typography, useTheme } from '@mui/material';
import Image from '@components/Image';
import { useStyles } from './styles';
import { useSignUpRedirect } from '~/hooks/useSignUpRedirect';

const GetStartedBlock: FC = () => {
  const { t } = useLocales();
  const theme = useTheme();
  const styles = useStyles(theme);
  const { signUpRedirect } = useSignUpRedirect();
  return (
    <Box sx={styles.container}>
      <Card sx={styles.card}>
        <Image alt="cover" src="/rocket.png" sx={styles.image} />
        <Box sx={styles.textBox}>
          <Box sx={styles.textAndButtonBox}>
            <Typography variant="h2" sx={styles.text}>
              {t('landing.get_started_with')}
            </Typography>
            <Button
              variant="contained"
              size="large"
              color="inherit"
              sx={styles.button}
              onClick={signUpRedirect}
            >
              {t('landing.get_started_now')}
            </Button>
          </Box>
        </Box>
      </Card>
    </Box>
  );
};

export default GetStartedBlock;
